import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { TranslationService } from '../../../shared/services/translations.service';
import { LanguageChangeService } from '../../../shared/services/language-change.service';

export const langGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  const translationService = inject(TranslationService);
  const languageService = inject(LanguageChangeService);

  const defaultLang = 'en';
  const lang = route.paramMap.get('lang');

  if (lang && translationService.validLangs.includes(lang)) {
    if (lang === defaultLang) {
      // redirect `/en/...` → `/...`
      return stripLangFromUrl(router, state.url);
    }
    languageService.setLanguage(lang);
    return true;
  }

  // invalid or missing → fallback
  languageService.setLanguage(defaultLang);
  return stripLangFromUrl(router, state.url);
};

function stripLangFromUrl(router: Router, url: string): UrlTree {
  const segments = url.split('/').filter(Boolean);
  segments.shift(); // remove lang
  return router.createUrlTree(['/', ...segments]);
}
